import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { isPlatformSystemAdmin } from '../utils/roleUtils';

/**
 * Redirects platform administrator accounts away from tenant customer/business dashboard routes.
 */
const TenantDashboardGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user } = useAuth();
  if (user && isPlatformSystemAdmin(user)) {
    return <Navigate to="/dashboard/platform" replace />;
  }
  return <>{children}</>;
};

export default TenantDashboardGuard;
